import {createContext} from 'react';

export const AnalyticsSearchIdContext = createContext<string | undefined>(undefined);
const AnalyticsSearchIdProvider = AnalyticsSearchIdContext.Provider;
export default AnalyticsSearchIdProvider;
